import React, { useState } from "react";
import { Container, Row, Col, Form, InputGroup } from "react-bootstrap";
import { Navbar, Offcanvas } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Logo from "../assets/images/logo.png";
import { FiPhoneCall } from "react-icons/fi";
import { LuMail } from "react-icons/lu";
import { FaRegUserCircle } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { setSearchQuery } from "../redux/slices/productSlice";
import { useNavigate } from "react-router-dom";
import { logout } from "../redux/slices/authSlice";
import { Dropdown } from "react-bootstrap";
const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const { user, token } = useSelector((state) => state.auth);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    dispatch(setSearchQuery(value));
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  return (
    <div>
      <div className="top-header">
        <Container>
          <Row className="align-items-center">
            <Col sm={2} >
              <Link to="/" className="header-logo">
                <img src={Logo} alt="Logo" loading="lazy" />
              </Link>
            </Col>
            <Col sm={10}>
              <ul className="header-contact">
                <li>
                  <a
                    href="mailto:carapglobal@gmail.com"
                    className="header-contact-link"
                  >
                    <div className="header-contact-icon">
                      <LuMail />
                    </div>
                    <div className="header-contact-text d-none d-md-block">
                      <h6>Get Inquiry ?</h6>
                      <span>carapglobal@gmail.com</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="tel:+971503580352" className="header-contact-link">
                    <div className="header-contact-icon">
                      <FiPhoneCall />
                    </div>
                    <div className="header-contact-text d-none d-md-block">
                      <h6>Get Call ?</h6>
                      <span>+971503580352</span>
                    </div>
                  </a>
                </li>
                <li>
                  {!token ? (
                    <Link to="/login" className="account-info">
                      <FaRegUserCircle />
                      <p>Sign In</p>
                    </Link>
                  ) : (
                    <Dropdown align="end">
                      <Dropdown.Toggle
                        className="account-info"
                        id="user-dropdown"
                      >
                        <FaRegUserCircle />
                        <p> {user?.name || "User"}</p>
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item as={Link} to="/profile">
                          Profile
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item onClick={handleLogout}>
                          Logout
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  )}
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="main-header">
        <Container>
          <Row>
            <Col xl={2} lg={3} md={4} sm={4} xs={5}>
              <Link to="/product" className="productbtn">
                All Products
              </Link>
              {/* <NavDropdown
                title={
                  <span>
                    <FaBars />
                    All Categories
                  </span>
                }
                id="nav-dropdown"
                className="cate-dropdown"
              >
                <NavDropdown.Item href="#">Category 1</NavDropdown.Item>
                <NavDropdown.Item href="#">Category 2</NavDropdown.Item>
                <NavDropdown.Item href="#">Category 3</NavDropdown.Item>
              </NavDropdown> */}
            </Col>
            <Col xl={10} lg={9} md={8} sm={8} xs={7}>
              <div>
                {["lg"].map((expand) => (
                  <Navbar key={expand} expand={expand} className="p-0">
                    <Container fluid>
                      <Navbar.Toggle
                        aria-controls={`offcanvasNavbar-expand-${expand}`}
                      />
                      <Navbar.Offcanvas
                        id={`offcanvasNavbar-expand-${expand}`}
                        aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                        placement="end"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title
                            id={`offcanvasNavbarLabel-expand-${expand}`}
                          >
                            Menu
                          </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Nav className="header-nav flex-grow-1 pe-3">
                            <NavLink
                              to="/"
                              className={({ isActive }) =>
                                isActive ? "nav-link active" : "nav-link"
                              }
                            >
                              Home
                            </NavLink>
                            <NavLink
                              to="/about"
                              className={({ isActive }) =>
                                isActive ? "nav-link active" : "nav-link"
                              }
                            >
                              About
                            </NavLink>
                            <NavLink
                              to="/faq"
                              className={({ isActive }) =>
                                isActive ? "nav-link active" : "nav-link"
                              }
                            >
                              FAQ
                            </NavLink>
                            <NavLink
                              to="/terms"
                              className={({ isActive }) =>
                                isActive ? "nav-link active" : "nav-link"
                              }
                            >
                              Terms
                            </NavLink>
                            <NavLink
                              to="/contact"
                              className={({ isActive }) =>
                                isActive ? "nav-link active" : "nav-link"
                              }
                            >
                              Contact
                            </NavLink>
                          </Nav>
                          <Form className="d-flex search-items">
                            <InputGroup className="me-2 search-input">
                              <InputGroup.Text>
                                <i className="bi bi-search"></i>
                              </InputGroup.Text>
                              <Form.Control
                                type="search"
                                placeholder="Search Products..."
                                aria-label="Search"
                                value={search}
                                onChange={handleSearchChange}
                              />
                            </InputGroup>
                          </Form>
                        </Offcanvas.Body>
                      </Navbar.Offcanvas>
                    </Container>
                  </Navbar>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Header;
